import React, { useState, useMemo, useEffect, useContext } from "react";
import Link from "next/link";
import { Container, Button, ButtonGroup, Col, Dropdown, Row } from "react-bootstrap";
import SearchArticleInput from "../../components/articleBlock/searchArticleInput";
import RecentTweets from "../../components/recentTweets/recentTweets";
import MainLayout from "../../components/MainLayout/MainLayout";
import SocialMediaLinks from "../../components/contentfulBlogs/SocialMediaLinks";
import client from "../../components/contentful/Contentful";
import ReactPaginate from "react-paginate";
import BlogCard from "../../components/contentfulBlogs/BlogCard";
import Head from "next/head";
import { useRouter } from "next/router";
import { appServerSideProps } from "../../utils/getAppService";
import BlogCategories from "../../components/contentfulBlogs/BlogCategories";
import BlogEmailCapture from "../../components/contentfulBlogs/BlogEmailCapture";
const NcaaPicksAndPredictions = ({ posts, user }) => {
  const router = useRouter();

  const [activeTab, setActiveTab] = useState("Picks & Predictions");
  const recordsPerPage = 12;
  const [pageCount, setPageCount] = useState(0);
  const [startItemIndex, setStartItemIndex] = useState(0);

  const currentItems = useMemo(() => {
    if (posts !== undefined && posts.length !== 0) {
      setPageCount(Math.ceil(posts.length / recordsPerPage));
      const endItemIndex = startItemIndex + recordsPerPage;
      return posts.slice(startItemIndex, endItemIndex);
    } else {
      return posts;
    }
  }, [posts, startItemIndex]);

  const handlePageClick = (event) => {
    const newStartIndex = (event.selected * recordsPerPage) % posts.length;
    setStartItemIndex(newStartIndex);
  };

  const handleNext = () => {
    if (startItemIndex + recordsPerPage < posts.length) {
      setStartItemIndex(startItemIndex + recordsPerPage);
    }
  };
  const handlePrev = () => {
    if (startItemIndex - recordsPerPage >= 0) {
      setStartItemIndex(startItemIndex - recordsPerPage);
    }
  };
  return (
    <>
      <Head>
        <title>Picks & Predictions | ShotQuality Wire</title>
        <meta name="description" content={"Basketball Picks & Predictions powered by the best data in the game."} />
        <meta property="og:title" content={"ShotQuality Picks & Predictions"} />
        <meta
          property="og:description"
          content={"Basketball Picks & Predictions powered by the best data in the game."}
        />
        {/* <meta property="og:image" content={`https:${blog?.fields?.postImage?.fields?.file?.url}`} /> */}
        <meta property="og:url" content={`https://shotqualitybets.com/blog/ncaa-picks-and-predictions`} />
      </Head>
      <MainLayout className="bg-white">
        <Container style={{ maxWidth: "1320px" }}>
          <Row style={{ paddingTop: "50px" }}>
            <Col md={10}>
              <h1>ShotQuality Picks & Predictions</h1>
              <h5>Basketball Picks & Predictions powered by the best data in the game.</h5>
            </Col>
            <Col md={2} style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <SocialMediaLinks />
            </Col>
          </Row>
          <BlogEmailCapture user={user} />
          <Row style={{ paddingBottom: "25px" }}>
            <BlogCategories activeTab={activeTab} setActiveTab={setActiveTab} usePath={true} />
            <Col md={4}>
              {posts.length > 0 && (
                <SearchArticleInput
                  allCategories={posts}
                  bestBetsPosts={[]}
                  weeklyRecapsPosts={[]}
                  SQBetsPodcastPosts={[]}
                  coachingPhilosophyPosts={[]}
                  collegeMensPosts={[]}
                  collegeWomens={[]}
                  nbaDraftPosts={[]}
                  bettingAnalysisPosts={[]}
                />
              )}
            </Col>
          </Row>
        </Container>
        <Container>
          <div className="row mb-3">
            {currentItems.length > 0 ? (
              currentItems.map((post, index) => (
                <div key={"blog" + index} className="col-lg-4 col-md-6 col-sm-12 pb-5">
                  <BlogCard post={post} isFromHomePage="blog" source="picks" user={user} />
                </div>
              ))
            ) : (
              <h4>No posts found</h4>
            )}
          </div>
          {posts?.length > recordsPerPage && (
            <>
              <div className="hidden">
                <ReactPaginate
                  className="articlePagination"
                  activeClassName="activePage"
                  breakLabel="..."
                  nextLabel=">"
                  onPageChange={handlePageClick}
                  pageRangeDisplayed={0}
                  pageCount={pageCount}
                  previousLabel="<"
                  renderOnZeroPageCount={null}
                />
              </div>
              <div className="float-right">
                <button className="btn btn-primary mr-3" disabled={startItemIndex == 0} onClick={handlePrev}>
                  Prev
                </button>
                <button
                  className="btn btn-primary"
                  disabled={startItemIndex + recordsPerPage > posts.length}
                  onClick={handleNext}
                >
                  Next
                </button>
              </div>
            </>
          )}
        </Container>
        <Container
          fluid
          style={{
            maxWidth: "1320px",
            padding: "0",
            backgroundColor: "#F2F4F6",
            paddingTop: "1rem",
            marginTop: "1rem",
          }}
        >
          <RecentTweets />
        </Container>
      </MainLayout>
    </>
  );
};

export const getServerSideProps = appServerSideProps(async ({ appService, cookies, params, query }) => {
  // export async function getServerSideProps() {
  const res = await client.getEntries({
    content_type: "blog",
    "fields.targetSite[in]": "ShotQualityBets",
    order: "-fields.published",
    // "metadata.tags[0].sys.id": "NCAA",
    // "metadata.tags.sys.id": "NCAA",
    // "metadata.tags[in]": "NCAA",
  });
  const posts = res.items.filter((it) => JSON.stringify(it.metadata.tags).includes("picks"));
  // const posts = res.items;

  const isUserLogged = appService.getUser();

  let user = null;

  if (isUserLogged) {
    user = await appService.get("api/account");
  }

  return {
    props: {
      posts,
      user,
    },
  };
});
export default NcaaPicksAndPredictions;
